import { createApp } from 'vue'
import WordDetail from '../components/WordDetail.vue'

export function mountWord() {
  const el = document.getElementById('word-app')
  if (!el) return

  createApp(WordDetail, {
    word: JSON.parse(el.dataset.word),
    review: JSON.parse(el.dataset.review || 'null'),
    referenceUrl: el.dataset.referenceUrl,
    contourUrl: el.dataset.contourUrl,
    deckUrl: el.dataset.deckUrl,
    practiceUrl: el.dataset.practiceUrl,
    unitUrl: el.dataset.unitUrl,
    backUrl: el.dataset.backUrl,
    subscribed: el.dataset.subscribed === 'true',
    dialect: el.dataset.dialect || 'south',
  }).mount(el)
}
